<script setup>
import NavLink from "@/components/NavLink.vue";
import { useCartStore } from "@/stores/CartStore";
import { storeToRefs } from "pinia";

const cartStore = useCartStore();
const { isEmpty } = storeToRefs(cartStore);
</script>

<template>
  <header>
    <nav class="navbar navbar-expand-md navbar-dark bg-dark">
      <div class="container-fluid">
        <RouterLink to="/"
          ><img class="logo" src="@/assets/navbar_logo.png" role="button"
        /></RouterLink>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto">
            <NavLink to="/">HOME</NavLink>
            <NavLink to="/pricing">PRICING</NavLink>
            <NavLink to="/legal">LEGAL</NavLink>
            <NavLink to="/about">ABOUT</NavLink>
          </ul>
          <a
            v-show="!isEmpty"
            @click="cartStore.showCart()"
            class="navbar-nav me-4"
            role="button"
          >
            <fa icon="cart-shopping" class="nav-link" />
            <span
              class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
            >
              {{ cartStore.count }}
            </span>
          </a>
        </div>
      </div>
    </nav>
  </header>
</template>
